import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    OrderTrackingByApi,
} from 'app/enums/label.enums'

import {
    CompanyWithParent,
} from '../Companies.types'

const getFields = (
    getAllowedValues: (val: Record<string, string>) => Record<string, string>,
): DTOCardFormField<keyof CompanyWithParent>[] => {
    return [{
        id: 'tracking',
        title: 'Allowed Tracking',
        fields: [{
            name: 'orderTrackingByApi',
            componentName: 'EnumSelector',
            allowedValues: getAllowedValues(OrderTrackingByApi),
            useDropdown: true,
            className: 'orderTrackingByApi',
            labelKey: 'Company.orderTrackingByApi',
        }],
    }]
}

export default getFields
